import React from 'react'

require('../../../../styles/scss/components/bubble-message.scss')

/** Positions any number of BubbleMessage children in a fixed, top-centered column so
 * multiple bubbles stack underneath each other instead of overlapping. */
export default ({ children }) => (
  <div className="bubble-message-stack">
    {children}
  </div>
)
